import { useExperience } from '@mc/experience'
import Experiment from '@mc/experiments-react'
import { LearnMoreLink } from '../mccerts-2548_v1-subscriptions-entry-point/LearnMoreLink'
import { SubscriptionNote } from '../mccerts-2548_v1-subscriptions-entry-point/SubscriptionNote'
import { MCCERTS_2624_HUB_SUBS_ROW_FLAG } from './constants'

const HubSubsNoteVariant = () => (
  // Defaults the lead-in to "Save when you purchase with", matching variant 3
  <SubscriptionNote learnMoreLink={<LearnMoreLink />} />
)

// Subs-awareness line under the hub hero CTA (V1 of the HP entry-point test).
// Enterprise members are excluded (can't purchase).
//
// This <Experiment> owns the flag's exposure — it must stay here, in the
// synchronously rendered hero, so visitors who bounce before BelowTheFold's
// ssr:false chunk mounts are still counted (HubSubsRowExp keeps track
// disabled for that reason). The wrapper fires for every bucket;
// trackExperimentViewed no-ops unless GrowthBook bucketed the user, and the
// flag's targeting excludes enterprise.
export const HubHeroSubsNote = () => {
  const { isEnterprise } = useExperience()

  if (isEnterprise) return null

  return (
    <Experiment
      name={MCCERTS_2624_HUB_SUBS_ROW_FLAG}
      variant_1={HubSubsNoteVariant}
    />
  )
}
